import { PlanetCardInfoType, PlanetLite } from '@apeiron/planet'
import { Box, styled, Typography } from '@mui/material'
import PlanetCard from '@src/components/planet/share/planetCard/PlanetCard'
import { PlanetTypeProvider } from '@src/contexts/planet/PlanetTypeContext'
import * as R from 'ramda'
import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'

const MainContainer = styled(Box)`
  padding: 20px;
  background: #171719;
`

const PlanetContainer = styled(Box)`
  align-items: center;
  display: flex;
  justify-content: center;
  ${props => props.theme.breakpoints.up('res1024')} {
    gap: 40px;
  }
  ${props => props.theme.breakpoints.down('res1024')} {
    gap: 10px;
  }
`

const StyledPlanetCard = styled(PlanetCard)`
  min-width: 140px;
  ${props => props.theme.breakpoints.up('res1024')} {
    width: 140px;
  }
  ${props => props.theme.breakpoints.down('res1024')} {
    width: 140px;
  }
`

const TextContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const PlanetDetailTitle = styled(Typography)`
  ${props => props.theme.breakpoints.up('res1024')} {
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
  }
  ${props => props.theme.breakpoints.down('res1024')} {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
  }
`

const PlanetAge = styled(Typography)`
  width: auto;
  text-align: left;
  ${props => props.theme.breakpoints.up('res1024')} {
    font-size: 16px;
    line-height: 18px;
    strong {
      color: #1d66bf;
      font-size: 20px;
      font-weight: 500;
    }
  }
  ${props => props.theme.breakpoints.down('res1024')} {
    font-size: 12px;
    line-height: 16px;
    white-space: pre-line;
    strong {
      color: #1d66bf;
      font-size: 16px;
      font-weight: 500;
    }
  }
`

const OrbitingPlanetPlanetCard: FC<Props> = props => {
  const { className, planet } = props

  const { t } = useTranslation()

  return (
    <MainContainer className={className}>
      <PlanetTypeProvider>
        {!R.isNil(planet) && (
          <>
            <PlanetContainer>
              <StyledPlanetCard
                infoType={PlanetCardInfoType.None}
                planet={planet}
                showInfo
              />
              {!R.isNil(planet) && (
                <TextContainer>
                  <PlanetDetailTitle>
                    {t('godiverse.orbital_track.planet_details')}
                  </PlanetDetailTitle>
                  <PlanetAge>
                    <Trans>
                      {t('godiverse.orbital_track.current_age', {
                        age: planet.age
                      })}
                    </Trans>
                  </PlanetAge>
                </TextContainer>
              )}
            </PlanetContainer>
          </>
        )}
      </PlanetTypeProvider>
    </MainContainer>
  )
}

type Props = {
  className?: string
  planet?: PlanetLite | null
}

export default OrbitingPlanetPlanetCard
